<template>
    <v-container style="background-color: #fff">
        <v-layout>
            <div v-html="content"></div>
        </v-layout>
    </v-container>
</template>

<script>
    import privacy from "@/assets/js/privacy"
    export default {
        name: "PrivacyContent",
        data(){
            return {
                content:privacy
            }
        }
    }
</script>

<style scoped>

</style>
